module.exports = __webpack_public_path__ + "img/arrow-service.aa971e67.svg";